import { Button, MenuItem, SelectChangeEvent } from "@mui/material";
import { Select } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import React, { Suspense, useContext, useEffect, useMemo, useRef } from "react";
import {
	COVERAGE,
	VEBToGeneralCoverageCodeType,
	VEB_TO_GENERAL_COVERAGE_CODE
} from "../../../../../../../constants/coverage";
import {
	AuthContext,
	DependentsContext,
	EligibleDependentContext,
	EnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../../contexts";
import { LazyCustomFormDialog, LazyPlanActions, VEBDisclaimer } from "../../../../../../shared";
import { Checkbox } from "@mui/material";
import { useState } from "react";
import { useCallback } from "react";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import { CustomInput, CustomSelectInput } from "../../../../../../shared/CustomInput";

import "./wholeLifeInsurance.css";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";
import {
	generateCancerKemperWaiveEnrollmentPayload,
	generateWholeLifeActivateVEBEnrollmentPayload
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { VEB_PLAN_NAME, VEB_PLAN_NAMES } from "../../../../../../../constants/plan";
import {
	PaycheckFrequency,
	VEBPlan,
	WholeLifeAge,
	WholeLifeChildPlanDetails,
	WholeLifeFaceAmountFrequency,
	WholeLifePlanCoverage,
	WholeLifePlanDetails,
	WholeLifePremiumAmount,
	WholeLifeStandardPremiumAmount,
	WholeLifeChildPremiumAmount
} from "../../../../../../../types/plan.types";
import { VEBPlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import { VEBEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../../../utils/api";
import { plan } from "../../../../../../../utils/api/plan/plan";
import VEBPlanHeader from "../../../../../../shared/enrollment/VEBPlanHeader/PlanHeader";
import { dateTimeZoneConverter, getFirstOfNextMonth } from "../../../../../../../utils/commonFunctions/date";
import { Member } from "../../../../../../../types/employee.types";
import {
	CoverageCode,
	VEBEnrollments,
	VEBEnrollmentSchema,
	VEBEnrollmentStandardDetails,
	VEBWholeLifeEnrollments
} from "../../../../../../../types/enrollment.types";
import { WholeLifeInsuranceChildPlanData } from "./wholeLifePlanData";
import WholeLifeInsurancePlanData from "./wholeLifePlanData.json";
import {
	getKemperAccidentEligibleDependents,
	getKemperWholeLifeEligibleDependents,
	getKemperWholeLifeEligibleDependentsV2
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";
import { VEBOpenEnrollment } from "../../../../../../../types/openEnrollment.types";
import { Paycheck } from "../../../../../../../types/paycheck.types";
import VEBPlanCard from "../../../../../../shared/VEBPlanCard/VEBPlanCard";
import { AddBeneficiary, Beneficiary } from "../../../../../../../types/addBeneficiary.types";
import VEBModal from "../../../../../../shared/VEBModal/VEBModal";
import { CustomDisclaimerDialogPropsType } from "../../../../../../../types/dialogProps.types";
import CustomEnrollmentDisclaimerDialog from "../../../../../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import { trackPromise } from "react-promise-tracker";
import { EligiblityDialogProps } from "../../../../../../../types/components/eligiblityDialogProps.types";
import EligiblityDialog from "../../../../eligiblityDialogs/EligiblityDialog";
import calculateAge, { getAgeInDays } from "../../../../../../../utils/commonFunctions/age";
import VEBBeneficiary from "../../../../VEBBeneficiary/VEBBeneficiary";
import { BV2Beneficiery } from "../../../../../../../types/BV2Beneficiery.types";
import { VEBPlanCodes2024 } from "../../../../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";
import ExistsDependentModelVEB from "../../../../../../shared/existsMemberModel/ExistsDependentModelVEB";

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
	({ theme }) => ({
		border: `1px solid ${theme.palette.divider}`,
		"&:not(:last-child)": {
			borderBottom: 0
		},
		"&:before": {
			display: "none"
		}
	})
);

const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
))(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "rgba(0, 0, 0, .03)",
	flexDirection: "row-reverse",
	"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
		transform: "rotate(90deg)"
	},
	"& .MuiAccordionSummary-content": {
		marginLeft: theme.spacing(1)
	}
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: "1px solid rgba(0, 0, 0, .125)"
}));

const KemperWholeLifeInsuaranceForm = ({
	VEBOpenEnrollment,
	getVEBEnrollmentInitData
}: VEBPlanFormProps): JSX.Element => {
	const [waiveReason, setWaiveReason] = useState("");
	const [writingNumber, setWritingNumber] = useState(1408);
	const { member, setMember } = useContext(AuthContext);
	const { dependents, setDependents } = useContext(DependentsContext);
	const [spouse, setSpouse] = useState<Member | null>(null);
	const [modalOpen, setModalOpen] = useState(false);
	const [age, setAge] = useState(0);
	const [allBeneficiaryDetails, setAllBeneficiaryDetails] = useState<Beneficiary | null>(null);
	const [isSmoker, setSmoker] = useState("smoker");
	const [expanded_panel, setExpandedPanel] = useState<string | false>("panel_beneficiary");
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [VEBWholeLifeOpenEnrollment, setVEBWholeLifeOpenEnrollment] = useState<any>({});
	const [wholeLifeInsurancePlan, setWholeLifePlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const [wholeLifePlan, seWholeLifePlan] = useState<WholeLifePlanDetails>(WholeLifeInsurancePlanData);
	const [allBeneficiary, setAllBeneficiary] = useState<AddBeneficiary>([]);
	const [addMemberPrimaryBeneficiary, setAddMemberPrimaryBeneficiary] = useState<AddBeneficiary>([]);
	const [addSpousePrimaryBeneficiary, setAddSpousePrimaryBeneficiary] = useState<AddBeneficiary>([]);
	const [addMemberContigentBeneficiary, setAddMemberContigentBeneficiary] = useState<AddBeneficiary>([]);
	const [addSpouseContigentBeneficiary, setAddSpouseContigentBeneficiary] = useState<AddBeneficiary>([]);
	const [selectCard, setSelectCard] = useState<string>("");
	const { eligiblity, setEligiblity } = useContext(EligibleDependentContext);
	const [wholeLifeChildPlan, seWholeLifeChildPlan] = useState<WholeLifeChildPlanDetails>(
		WholeLifeInsuranceChildPlanData
	);
	const [prevWritingNumber, setPrevWritingNumber] = useState(1408);
	const [showWritingNumberValidateButton, setShowWritingNumberValidateButton] = useState(false);
	const { theme } = useContext(ThemeContext);
	const { paycheck } = useContext(PaycheckContext);
	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [coverage_for, setCoverageFor] = useState("");
	const [memberFaceAmount, setMemberFaceAmount] = useState<null | number>(null);
	const [spouseFaceAmount, setSpouseFaceAmount] = useState<null | number>(null);
	const [childBenefitPlan, setChildBenefitPlan] = useState<null | number>(null);
	const [hasSelectedRider, setHasSelectedRider] = useState<boolean>(false);
	const [childWholeLifePremiumAmount, setChildWholeLifePremiumAmount] = useState<number>(0);
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: "Whole life"
	});
	const [memberWeeklyPremium, setmemberWeeklyPremium] = useState<number>(0);
	const [memberAccidentalDeath, setmemberAccidentalDeath] = useState<number>(0);
	const [hasMemberAccidentalDeath, setHasMemberAccidentalDeath] = useState(true);
	const [hasMemberWaiverPremium, setHasMemberWaiverPremium] = useState(true);
	const [hasSpouseAccidentalDeath, setHasSpouseAccidentalDeath] = useState(true);
	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const isDependentExistsModelOpenRef = useRef(false);
	const [hasMemberTobacco, setHasMemberTobacco] = useState(false);
	const [hasSpouseTobacco, setHasSpouseTobacco] = useState(false);
	const [hasSpouseWaiverPremium, setHasSpouseWaiverPremium] = useState(true);
	const [memberWaiverPremium, setmemberWaiverPremium] = useState<number>(0);
	const [spouseWeeklyPremium, setspouseWeeklyPremium] = useState<number>(0);
	const [spouseAccidentalDeath, setspouseAccidentalDeath] = useState<number>(0);
	const [spouseWaiverPremium, setspouseWaiverPremium] = useState<number>(0);
	const [totalPremium, setTotalPremium] = useState<number>(0);
	const [expanded, setExpanded] = useState<string | false>("panel1");
	const [showMember, setShowMember] = useState(false);
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);
	const [hasReadTC, setHasReadTC] = useState(false);
	const [emailDisclaimer, setEmailDisclaimer] = useState("");
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const [dependentList, setDependentList] = useState<Member[]>([]);
	const [children, setChildren] = useState<Member[]>([]);
	const { groupOwner } = useContext(GroupOwnerContext);
	const [primaryMemberBeneficiary, setPrimaryMemberBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const [contingentMemberBeneficiary, setContingentMemberBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const [primarySpouseBeneficiary, setPrimarySpouseBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const [contingentSpouseBeneficiary, setContingentSpouseBeneficiary] = useState({
		percentage: 0,
		count: 0
	});
	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};
	const [editData, setEditData] = useState<null | Beneficiary>(null);
	const [hasOpenedEligiblity, setHasOpenedEligiblity] = useState<boolean>(false);
	//BV2 State
	const [BV2employeePrimaryBeneficiary, setBV2EmployeePrimaryBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2employeeContingentBeneficiary, setBV2EmployeeContingentBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2spousePrimaryBeneficiary, setBV2SpousePrimaryBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2spouseContingentBeneficiary, setBV2SpouseContingentBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2childPrimaryBeneficiary, setBV2ChildPrimaryBeneficiary] = useState<BV2Beneficiery[]>([]);
	const [BV2childContingentBeneficiary, setBV2ChildContingentBeneficiary] = useState<BV2Beneficiery[]>([]);

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.whole_life) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setWholeLifePlan(Object.assign({}, _planPaylaod));

				setVEBWholeLifeOpenEnrollment(Object.assign({}, VEBOpenEnrollment[idx]));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	const validateBeneficiary = useCallback((beneficiary: BV2Beneficiery[], type: "PRIMARY" | "CONTINGENT") => {
		let sum = 0,
			i;
		for (i = 0; i < beneficiary.length; i++) {
			const { percentage } = beneficiary[i];
			sum += percentage;
		}
		return sum;
	}, []);

	const handleBeneficiaryValidate = useCallback(() => {
		let isValid = true;
		if (coverage_for === "Employee Only" || coverage_for === "Employee & Spouse") {
			// Primary Beneficiary
			if (BV2employeePrimaryBeneficiary.length === 0) {
				alert("Employee must have alteast One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (BV2employeePrimaryBeneficiary.length > 4) {
				alert("Employee can have atmost Four Primary Beneficiaries!");
				isValid = false;
				return isValid;
			}
			const employeePrimaryPercentageSum = validateBeneficiary(BV2employeePrimaryBeneficiary, "PRIMARY");
			if (employeePrimaryPercentageSum !== 100 && employeePrimaryPercentageSum !== 0) {
				alert("Primary Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}

			// Contingent Beneficiary
			if (BV2employeeContingentBeneficiary.length !== 0) {
				if (BV2employeeContingentBeneficiary.length > 4) {
					alert("Employee can have atmost Four Contingent Beneficiaries!");
					isValid = false;
					return isValid;
				}

				const employeeContingentPercentageSum = validateBeneficiary(
					BV2employeeContingentBeneficiary,
					"CONTINGENT"
				);
				if (employeeContingentPercentageSum !== 100 && employeeContingentPercentageSum !== 0) {
					alert("Contingent Beneficiary Percentage must be all total 100%!");
					isValid = false;
					return isValid;
				}
			}
		}
		if (coverage_for === "Employee & Spouse") {
			// Primary Beneficiary
			if (BV2spousePrimaryBeneficiary.length === 0) {
				alert("Spouse must have alteast one Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (BV2spousePrimaryBeneficiary.length > 4) {
				alert("Spouse can have atmost Four Primary Beneficiaries!");
				isValid = false;
				return isValid;
			}
			const spousePrimaryPercentageSum = validateBeneficiary(BV2spousePrimaryBeneficiary, "PRIMARY");
			if (spousePrimaryPercentageSum !== 100 && spousePrimaryPercentageSum !== 0) {
				alert("Spouse Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}

			// Contingent Beneficiary
			if (BV2spouseContingentBeneficiary.length !== 0) {
				if (BV2spouseContingentBeneficiary.length > 4) {
					alert("Spouse can have atmost Four Contingent Beneficiary!");
					isValid = false;
					return isValid;
				}

				const contingentPercentageSum = validateBeneficiary(BV2spouseContingentBeneficiary, "CONTINGENT");
				if (contingentPercentageSum !== 100 && contingentPercentageSum !== 0) {
					alert("Contingent Beneficiary Percentage must be all total 100%!");
					isValid = false;
					return isValid;
				}
			}
		}
	}, [
		BV2employeeContingentBeneficiary,
		BV2employeePrimaryBeneficiary,
		BV2spouseContingentBeneficiary,
		BV2spousePrimaryBeneficiary,
		coverage_for,
		validateBeneficiary
	]);

	//End BV2 State

	const handleAddBeneficiaryDetails = useCallback(
		(eventName: string, beneficiaryAllDetails: any) => {
			if (member && eventName === "member-card-estate") {
				if ([...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].length === 0) {
					const newBeneficiary: Beneficiary = {
						first_name: member?.first_name,
						last_name: member?.last_name,
						type: "PRIMARY",
						enrollment_id: member?._id,
						insured_SSN: member?.SSN,
						relation: member.relationship,
						address_line_1: member.address_line_1,
						address_line_2: member?.address_line_2,
						state: member?.state,
						ZIP: member?.ZIP,
						SSN: member?.SSN,
						date_of_birth: new Date(member?.date_of_birth === undefined ? "" : member?.date_of_birth),
						gender: member.gender,
						percentage: 100,
						phone_number: member.phone_number,
						canEdit: false
					};
					setAddMemberPrimaryBeneficiary([...addMemberPrimaryBeneficiary, newBeneficiary]);
					setSelectCard("member-card");
				} else {
					alert("Percentage should be less tha 100.Please delete any beneficiary");
					setModalOpen(false);
				}
			} else if (eventName === "member-card-spouse") {
				if ([...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].length === 0) {
					const spouseDetails = dependents.filter((val: any, index: number) => {
						if (val.relationship === "SPOUSE") {
							return true;
						} else {
							return false;
						}
					})[0];
					const newBeneficiary: Beneficiary = {
						first_name: spouseDetails?.first_name,
						last_name: spouseDetails?.last_name,
						type: "PRIMARY",
						enrollment_id: spouseDetails?._id,
						insured_SSN: spouseDetails?.SSN,
						relation: spouseDetails?.relationship,
						address_line_1: spouseDetails?.address_line_1,
						address_line_2: spouseDetails?.address_line_2,
						state: spouseDetails?.state,
						ZIP: spouseDetails?.ZIP,
						SSN: spouseDetails?.SSN,
						date_of_birth: spouseDetails?.date_of_birth
							? new Date(spouseDetails.date_of_birth)
							: new Date(),
						gender: spouseDetails?.gender,
						percentage: 100,
						phone_number: spouseDetails.phone_number,
						canEdit: false
					};
					setAddMemberPrimaryBeneficiary([...addMemberPrimaryBeneficiary, newBeneficiary]);
					setSelectCard("member-card");
				} else {
					alert("Percentage should be less tha 100.Please delete any beneficiary");
					setModalOpen(false);
				}
			} else if (eventName === "spouse-card-spouse" || eventName === "spouse-card-estate") {
				if ([...addSpousePrimaryBeneficiary, ...addSpouseContigentBeneficiary].length === 0) {
					const spouseDetails = dependents.filter((val: any, index: number) => {
						if (val.relationship === "SPOUSE") {
							return true;
						} else {
							return false;
						}
					})[0];
					let newBeneficiary: Beneficiary | null = null;
					if (eventName === "spouse-card-spouse") {
						newBeneficiary = {
							first_name: member?.first_name,
							last_name: member?.last_name,
							type: "PRIMARY",
							enrollment_id: member?._id,
							insured_SSN: member?.SSN,
							relation: member?.relationship,
							address_line_1: member?.address_line_1,
							address_line_2: member?.address_line_2,
							state: member?.state,
							ZIP: member?.ZIP,
							SSN: member?.SSN,
							date_of_birth: member?.date_of_birth ? new Date(member.date_of_birth) : new Date(),
							gender: member?.gender,
							percentage: 100,
							phone_number: member.phone_number,
							canEdit: false
						};
					} else {
						newBeneficiary = {
							first_name: spouseDetails?.first_name,
							last_name: spouseDetails?.last_name,
							type: "PRIMARY",
							enrollment_id: spouseDetails?._id,
							insured_SSN: spouseDetails?.SSN,
							relation: spouseDetails?.relationship,
							address_line_1: spouseDetails?.address_line_1,
							address_line_2: spouseDetails?.address_line_2,
							state: spouseDetails?.state,
							ZIP: spouseDetails?.ZIP,
							SSN: spouseDetails?.SSN,
							date_of_birth: spouseDetails?.date_of_birth
								? new Date(spouseDetails.date_of_birth)
								: new Date(),
							gender: spouseDetails?.gender,
							percentage: 100,
							phone_number: spouseDetails.phone_number,
							canEdit: false
						};
					}
					setAddSpousePrimaryBeneficiary([...addSpousePrimaryBeneficiary, newBeneficiary]);
					setSelectCard("spouse-card");
				} else {
					alert("Percentage should be less tha 100.Please delete any beneficiary");
					setModalOpen(false);
				}
			} else if (eventName === "member-card-add-beneficiary") {
				setSelectCard("member-card");
				setModalOpen(true);
			} else if (eventName === "spouse-card-add-beneficiary") {
				setSelectCard("spouse-card");
				setModalOpen(true);
			} else if (eventName === "save-beneficiary") {
				if (selectCard === "member-card") {
					if (
						(primaryMemberBeneficiary.percentage +
							contingentMemberBeneficiary.percentage +
							parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
							200 &&
							(beneficiaryAllDetails.type === "PRIMARY"
								? primaryMemberBeneficiary.percentage +
										parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
								  100
								: contingentMemberBeneficiary.percentage +
										parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
								  100)) ||
						editData !== null
					) {
						if (editData !== null) {
							const editedMemberPrimaryBeneficiary = addMemberPrimaryBeneficiary.map(
								(memberPrimary: Beneficiary, index: number) => {
									if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
										return {
											first_name: beneficiaryAllDetails?.firstName,
											last_name: beneficiaryAllDetails?.lastName,
											type: beneficiaryAllDetails.type,
											enrollment_id: beneficiaryAllDetails?._id,
											insured_SSN: beneficiaryAllDetails?.ssn,
											relation: beneficiaryAllDetails?.relationship,
											address_line_1: beneficiaryAllDetails?.address,
											address_line_2: beneficiaryAllDetails?.address2,
											state: beneficiaryAllDetails?.state,
											ZIP: beneficiaryAllDetails?.zipCode,
											SSN: beneficiaryAllDetails?.ssn,
											date_of_birth:
												beneficiaryAllDetails.dob !== ""
													? new Date(beneficiaryAllDetails.date_of_birth)
													: new Date(),
											gender: beneficiaryAllDetails?.gender,
											percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
											phone_number: beneficiaryAllDetails.telephone,
											canEdit: true
										};
									} else {
										return memberPrimary;
									}
								}
							);
							setAddMemberPrimaryBeneficiary(editedMemberPrimaryBeneficiary);
							const editedMemberContingentBeneficiary = addMemberContigentBeneficiary.map(
								(memberPrimary: Beneficiary, index: number) => {
									if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
										return {
											first_name: beneficiaryAllDetails?.firstName,
											last_name: beneficiaryAllDetails?.lastName,
											type: beneficiaryAllDetails.type,
											enrollment_id: beneficiaryAllDetails?._id,
											insured_SSN: beneficiaryAllDetails?.ssn,
											relation: beneficiaryAllDetails?.relationship,
											address_line_1: beneficiaryAllDetails?.address,
											address_line_2: beneficiaryAllDetails?.address2,
											state: beneficiaryAllDetails?.state,
											ZIP: beneficiaryAllDetails?.zipCode,
											SSN: beneficiaryAllDetails?.ssn,
											date_of_birth:
												beneficiaryAllDetails.dob !== ""
													? new Date(beneficiaryAllDetails.date_of_birth)
													: new Date(),
											gender: beneficiaryAllDetails?.gender,
											percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
											phone_number: beneficiaryAllDetails.telephone,
											canEdit: true
										};
									} else {
										return memberPrimary;
									}
								}
							);
							setAddMemberContigentBeneficiary(editedMemberContingentBeneficiary);
							setEditData(null);
						} else {
							if (beneficiaryAllDetails.type === "PRIMARY") {
								const newBeneficiary: Beneficiary = {
									first_name: beneficiaryAllDetails?.firstName,
									last_name: beneficiaryAllDetails?.lastName,
									type: beneficiaryAllDetails.type,
									enrollment_id: beneficiaryAllDetails?._id,
									insured_SSN: beneficiaryAllDetails?.ssn,
									relation: beneficiaryAllDetails?.relationship,
									address_line_1: beneficiaryAllDetails?.address,
									address_line_2: beneficiaryAllDetails?.address2,
									state: beneficiaryAllDetails?.state,
									ZIP: beneficiaryAllDetails?.zipCode,
									SSN: beneficiaryAllDetails?.ssn,
									date_of_birth:
										beneficiaryAllDetails.dob !== ""
											? new Date(beneficiaryAllDetails.date_of_birth)
											: new Date(),
									gender: beneficiaryAllDetails?.gender,
									percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
									phone_number: beneficiaryAllDetails.telephone,
									canEdit: true
								};
								setAddMemberPrimaryBeneficiary([...addMemberPrimaryBeneficiary, newBeneficiary]);
							} else {
								if (editData !== null) {
									const editedMemberContigentBeneficiary = addMemberContigentBeneficiary.map(
										(memberPrimary: Beneficiary, index: number) => {
											if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
												return {
													first_name: beneficiaryAllDetails?.firstName,
													last_name: beneficiaryAllDetails?.lastName,
													type: beneficiaryAllDetails.type,
													enrollment_id: beneficiaryAllDetails?._id,
													insured_SSN: beneficiaryAllDetails?.ssn,
													relation: beneficiaryAllDetails?.relationship,
													address_line_1: beneficiaryAllDetails?.address,
													address_line_2: beneficiaryAllDetails?.address2,
													state: beneficiaryAllDetails?.state,
													ZIP: beneficiaryAllDetails?.zipCode,
													SSN: beneficiaryAllDetails?.ssn,
													date_of_birth:
														beneficiaryAllDetails.dob !== ""
															? new Date(beneficiaryAllDetails.date_of_birth)
															: new Date(),
													gender: beneficiaryAllDetails?.gender,
													percentage: parseInt(
														beneficiaryAllDetails.percentage.substring(0, 2)
													),
													phone_number: beneficiaryAllDetails.telephone,
													canEdit: true
												};
											} else {
												return memberPrimary;
											}
										}
									);
									setAddMemberContigentBeneficiary(editedMemberContigentBeneficiary);
									setEditData(null);
								} else {
									const newBeneficiary: Beneficiary = {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
									setAddMemberContigentBeneficiary([
										...addMemberContigentBeneficiary,
										newBeneficiary
									]);
								}
							}
						}
					} else {
						alert("Percentage should be less tha 100. Please delete any beneficiary");
						setModalOpen(false);
					}
				} else {
					if (editData !== null) {
						const editedSpousePrimaryBeneficiary = addSpousePrimaryBeneficiary.map(
							(SpousePrimary: Beneficiary, index: number) => {
								if (SpousePrimary.enrollment_id === beneficiaryAllDetails._id) {
									return {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
								} else {
									return SpousePrimary;
								}
							}
						);
						setAddSpousePrimaryBeneficiary(editedSpousePrimaryBeneficiary);
						const editedSpouseContingentBeneficiary = addSpouseContigentBeneficiary.map(
							(SpousePrimary: Beneficiary, index: number) => {
								if (SpousePrimary.enrollment_id === beneficiaryAllDetails._id) {
									return {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
								} else {
									return SpousePrimary;
								}
							}
						);
						setAddSpouseContigentBeneficiary(editedSpouseContingentBeneficiary);
						setEditData(null);
					} else {
						if (
							(primarySpouseBeneficiary.percentage +
								contingentSpouseBeneficiary.percentage +
								parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
								200 &&
								(beneficiaryAllDetails.type === "PRIMARY"
									? primarySpouseBeneficiary.percentage +
											parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
									  100
									: contingentSpouseBeneficiary.percentage +
											parseInt(beneficiaryAllDetails.percentage.substring(0, 2)) <
									  100)) ||
							editData !== null
						) {
							if (beneficiaryAllDetails.type === "PRIMARY") {
								if (editData !== null) {
									const editedSpousePrimaryBeneficiary = addSpousePrimaryBeneficiary.map(
										(memberPrimary: Beneficiary, index: number) => {
											if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
												return {
													first_name: beneficiaryAllDetails?.firstName,
													last_name: beneficiaryAllDetails?.lastName,
													type: beneficiaryAllDetails.type,
													enrollment_id: beneficiaryAllDetails?._id,
													insured_SSN: beneficiaryAllDetails?.ssn,
													relation: beneficiaryAllDetails?.relationship,
													address_line_1: beneficiaryAllDetails?.address,
													address_line_2: beneficiaryAllDetails?.address2,
													state: beneficiaryAllDetails?.state,
													ZIP: beneficiaryAllDetails?.zipCode,
													SSN: beneficiaryAllDetails?.ssn,
													date_of_birth:
														beneficiaryAllDetails.dob !== ""
															? new Date(beneficiaryAllDetails.date_of_birth)
															: new Date(),
													gender: beneficiaryAllDetails?.gender,
													percentage: parseInt(
														beneficiaryAllDetails.percentage.substring(0, 2)
													),
													phone_number: beneficiaryAllDetails.telephone,
													canEdit: true
												};
											} else {
												return memberPrimary;
											}
										}
									);
									setAddSpousePrimaryBeneficiary(editedSpousePrimaryBeneficiary);
									setEditData(null);
								} else {
									const newBeneficiary: Beneficiary = {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
									setAddSpousePrimaryBeneficiary([...addSpousePrimaryBeneficiary, newBeneficiary]);
								}
							} else {
								if (editData !== null) {
									const editedSpouseContigentBeneficiary = addSpouseContigentBeneficiary.map(
										(memberPrimary: Beneficiary, index: number) => {
											if (memberPrimary.enrollment_id === beneficiaryAllDetails._id) {
												return {
													first_name: beneficiaryAllDetails?.firstName,
													last_name: beneficiaryAllDetails?.lastName,
													type: beneficiaryAllDetails.type,
													enrollment_id: beneficiaryAllDetails?._id,
													insured_SSN: beneficiaryAllDetails?.ssn,
													relation: beneficiaryAllDetails?.relationship,
													address_line_1: beneficiaryAllDetails?.address,
													address_line_2: beneficiaryAllDetails?.address2,
													state: beneficiaryAllDetails?.state,
													ZIP: beneficiaryAllDetails?.zipCode,
													SSN: beneficiaryAllDetails?.ssn,
													date_of_birth:
														beneficiaryAllDetails.dob !== ""
															? new Date(beneficiaryAllDetails.date_of_birth)
															: new Date(),
													gender: beneficiaryAllDetails?.gender,
													percentage: parseInt(
														beneficiaryAllDetails.percentage.substring(0, 2)
													),
													phone_number: beneficiaryAllDetails.telephone,
													canEdit: true
												};
											} else {
												return memberPrimary;
											}
										}
									);
									setAddSpouseContigentBeneficiary(editedSpouseContigentBeneficiary);
									setEditData(null);
								} else {
									const newBeneficiary: Beneficiary = {
										first_name: beneficiaryAllDetails?.firstName,
										last_name: beneficiaryAllDetails?.lastName,
										type: beneficiaryAllDetails.type,
										enrollment_id: beneficiaryAllDetails?._id,
										insured_SSN: beneficiaryAllDetails?.ssn,
										relation: beneficiaryAllDetails?.relationship,
										address_line_1: beneficiaryAllDetails?.address,
										address_line_2: beneficiaryAllDetails?.address2,
										state: beneficiaryAllDetails?.state,
										ZIP: beneficiaryAllDetails?.zipCode,
										SSN: beneficiaryAllDetails?.ssn,
										date_of_birth:
											beneficiaryAllDetails.dob !== ""
												? new Date(beneficiaryAllDetails.date_of_birth)
												: new Date(),
										gender: beneficiaryAllDetails?.gender,
										percentage: parseInt(beneficiaryAllDetails.percentage.substring(0, 2)),
										phone_number: beneficiaryAllDetails.telephone,
										canEdit: true
									};
									setAddSpouseContigentBeneficiary([
										...addSpouseContigentBeneficiary,
										newBeneficiary
									]);
								}
							}
						} else {
							alert("Percentage should be less tha 100. Please delete any beneficiary");
							setModalOpen(false);
						}
					}
				}
				setModalOpen(false);
			} else {
				setModalOpen(false);
			}
			// const { name, checked } = event.target;
			// if (name === "member-death-chronic-illness") {
			// 	setHasMemberAccidentalDeath(checked);
			// } else {
			// 	setHasSpouseAccidentalDeath(checked);
			// }
		},
		[
			member,
			addMemberPrimaryBeneficiary,
			addMemberContigentBeneficiary,
			dependents,
			addSpousePrimaryBeneficiary,
			addSpouseContigentBeneficiary,
			selectCard,
			primaryMemberBeneficiary.percentage,
			contingentMemberBeneficiary.percentage,
			editData,
			primarySpouseBeneficiary.percentage,
			contingentSpouseBeneficiary.percentage
		]
	);

	const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
		setExpanded(newExpanded ? panel : false);
	};

	const handleBeneficiaryChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
		setExpandedPanel(newExpanded ? panel : false);
	};

	const handleAgreedTCCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setHasReadTC(checked);
	};

	const handleCoverageChange = (event: SelectChangeEvent) => {
		const { value } = event.target;
		setCoverageFor(value);
		if (value === "Employee Only") {
			setShowMember(true);
			setspouseAccidentalDeath(0);
			setspouseWaiverPremium(0);
			setspouseWeeklyPremium(0);
			setSpouseFaceAmount(null);
		} else if (value === "Employee & Spouse") {
			setShowMember(false);
			const dependent_list = dependents.filter(
				(dependent, index) => dependent.relationship?.toLocaleUpperCase() === "SPOUSE"
			);
			setDependentList(dependent_list);
		} else if (value === "Employee & Dependents") {
			setShowMember(false);
			const dependent_list = dependents.filter(
				(dependent, index) => dependent.relationship?.toLocaleUpperCase() !== "SPOUSE"
			);
			setDependentList(dependent_list);
		} else if (value === "Employee & Family") {
			setShowMember(false);
			setDependentList(dependents);
		} else {
		}
	};

	const handleChildrenBenefitAmount = (event: SelectChangeEvent) => {
		const { value } = event.target;
		if (value === "") {
			setChildBenefitPlan(null);
			setHasSelectedRider(false);
		} else {
			setChildBenefitPlan(parseInt(value));
			setHasSelectedRider(true);
		}
	};

	const handleChronicIllnessChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, checked } = event.target;
		if (name === "member-death-chronic-illness") {
			setHasMemberAccidentalDeath(checked);
		} else {
			setHasSpouseAccidentalDeath(checked);
		}
	}, []);

	const handleWaiverPremiumChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, checked } = event.target;
		if (name === "member-waiver-premium") {
			setHasMemberWaiverPremium(checked);
		} else {
			setHasSpouseWaiverPremium(checked);
		}
	}, []);

	const hableTobaccoToggle = useCallback(
		async (event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, checked } = event.target;
			if (name === "member-tobacco") {
				setHasMemberTobacco(checked);
				const response = await trackPromise(
					api.enrollment.updateVebEnrollment(
						{
							is_tobacco: checked
						},
						"member",
						member?._id
					)
				);
				setMember(response);
			} else {
				const spouseDetails = dependents.find((val, index) => val.relationship === "SPOUSE");
				if (spouseDetails) {
					setHasSpouseTobacco(checked);
					const response = await trackPromise(
						api.enrollment.updateVebEnrollment(
							{
								is_tobacco: checked
							},
							"member",
							spouseDetails._id
						)
					);
					const modifiedDependents = dependents.map((dependent, index) => {
						if (dependent.relationship === "SPOUSE") {
							return response;
						} else {
							return dependent;
						}
					});
					setDependents(Object.assign([], modifiedDependents));
					setDependentList(Object.assign([], [response]));
				}
			}
		},
		[dependents, member?._id, setDependents, setMember]
	);

	const handlePlanChange = (event: SelectChangeEvent) => {
		const { name, value } = event.target;
		if (name === "member_face_amount") {
			if (value === "") {
				setMemberFaceAmount(null);
			} else {
				setMemberFaceAmount(parseInt(value));
			}
		} else if (name === "spouse_face_amount") {
			if (value === "") {
				setSpouseFaceAmount(null);
			} else {
				setSpouseFaceAmount(parseInt(value));
			}
		} else {
			setSpouseFaceAmount(parseInt(value));
		}
	};

	const handleWritingNumberChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target as HTMLInputElement;
			setWritingNumber(Number(value));
			if (Number(value) !== prevWritingNumber) {
				setShowWritingNumberValidateButton(true);
			} else {
				setShowWritingNumberValidateButton(false);
			}
		},
		[prevWritingNumber]
	);

	const [enrollmentDisclaimerDialogProps, setEnrollmentDisclaimerDialogProps] =
		useState<CustomDisclaimerDialogPropsType>({
			openDialog: false,
			title: "Disclaimer",
			content:
				"Whole Life : I hereby apply to Reserve National Insurance Company for a life insurance certificate to be issued solely and entirely in reliance upon the written answers to the foregoing questions and/or information obtained by the Company in its underwriting process. I agree and understand that no certificate will be in force until the effective date specified by the Company. I have read or had read to me all the questions and answers in this application and such answers to the best of my (our) knowledge and belief are true and complete. I understand and agree that any falsity of any answer or statement in this application which materially affects the acceptance of the risk or hazard assumed by the Company may bar the right to recovery under any certificate issued. FRAUD STATEMENT: Any person who knowingly presents a false or fraudulent claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in State prison.",

			inputFields: [
				{
					name: "Email Discalimer",
					value: emailDisclaimer,
					placeholder: "Enter Email"
				}
			],
			actions: [
				{
					label: "Email Disclaimer",
					callback: () => {
						null;
						// setEnrollmentDisclaimerDialogProps(
						// 	Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
						// );
					}
				}
			]
		});

	const findAmount = (premiumArray: any, value: any) => {
		return premiumArray.find((val: any, index: any) => {
			if (value !== null && value === val.face_amount) {
				return true;
			} else {
				return false;
			}
		});
	};

	const handleEdit = useCallback((data: Beneficiary, cardId: string) => {
		setSelectCard(cardId);
		setEditData(data);
		setModalOpen(true);
	}, []);
	const handleDelete = useCallback(
		(data: Beneficiary, cardId: string) => {
			setSelectCard(cardId);
			if (cardId === "member-card" && data.type === "PRIMARY") {
				setAddMemberPrimaryBeneficiary(
					addMemberPrimaryBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			} else if (cardId === "member-card" && data.type === "CONTINGENT") {
				setAddMemberContigentBeneficiary(
					addMemberContigentBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			} else if (cardId === "spouse-card" && data.type === "CONTINGENT") {
				setAddSpouseContigentBeneficiary(
					addSpouseContigentBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			} else {
				setAddSpousePrimaryBeneficiary(
					addSpousePrimaryBeneficiary.filter((val: Beneficiary, index: number) => {
						return val.enrollment_id !== data.enrollment_id;
					})
				);
			}
		},
		[
			addMemberPrimaryBeneficiary,
			addMemberContigentBeneficiary,
			addSpousePrimaryBeneficiary,
			addSpouseContigentBeneficiary
		]
	);
	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || VEBOpenEnrollment === null || VEBOpenEnrollment.length === 0) {
			return;
		}
		const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } = generateCancerKemperWaiveEnrollmentPayload(
			wholeLifeInsurancePlan,
			VEB_PLAN_NAME.kemper.wholeLife.standard_whole_life,
			VEB_PLAN_NAME.kemper.wholeLife.standard_whole_life,
			null,
			groupOwner,
			member,
			waiveReason,
			VEBOpenEnrollmentId as unknown as string,
			false
		);
		const VEBEnrollmentPayload: VEBEnrollmentPayload = {
			standard_details: VEBEnrollmentStandardDetails,
			common_details: VEBEnrollmentCommonDetails,
			isRider: false
		};
		const response = await trackPromise(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
		getVEBEnrollmentInitData();
		deleteCurrentEnrollment();
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=2`);
	}, [
		member,
		VEBOpenEnrollment,
		wholeLifeInsurancePlan,
		groupOwner,
		waiveReason,
		VEBOpenEnrollmentId,
		getVEBEnrollmentInitData,
		deleteCurrentEnrollment,
		urlSearchParams,
		history
	]);

	const handleIsActivelyWorkingCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIsActivelyWorking(checked);
	};

	const handleSubmitBeneficiary = useCallback((value: any) => {
		// setAddBeneficiaryDetails(
		// 	Object.assign({}, addBeneficiaryDetails, {
		// 		Name: value.beneficiaryName,
		// 		Relation: value.relationship,
		// 		Percentage: parseInt(value.percentage.split(" ")[0]),
		// 		Type: value.type.substr(0, 1)
		// 	})
		// );
	}, []);

	const handleValidation = useCallback((): boolean => {
		if (coverage_for === null || memberFaceAmount === null) {
			alert("Please fill all required fields");
			return false;
		}
		if (hasReadTC === false) {
			alert("Please agree to the Disclaimer");
			return false;
		}
		if (isActivelyWorking === false) {
			alert("You must actively working 20 hours or more to enroll");
			return false;
		}
		return true;
	}, [memberFaceAmount, coverage_for, isActivelyWorking, hasReadTC]);

	const generatePayload = useCallback(
		(VEBEnrollments: VEBWholeLifeEnrollments[], VEBOpenEnrollment: VEBOpenEnrollment, paycheck: Paycheck) => {
			// console.log("member", member);
			const VEBEnrollmentPayload: VEBEnrollmentPayload = {
				isRider: hasSelectedRider ? true : false,
				standard_details: [],
				common_details: {
					agent_id: null,
					location_number: 0,
					location_name: "",
					group_number: 0,
					group_name: "",
					plan_object_id: "",
					plan_code: "",
					plan_name: "",
					base_plan_name: "",
					sub_plan: null,
					insured_object_id: "",
					insured_SSN: "",
					enrollment_status: null,
					unenrolled_reason: null,
					waive_reason: null,
					termination_reason: null,
					writing_number: 0,
					enrollment_date: null,
					effective_date: null,
					termination_date: null,
					open_enrollment_id: null,
					total_premium: 0,
					enrollment_paycheck_id: undefined
				}
			};
			VEBEnrollments.forEach(async (VEBEnrollment: VEBWholeLifeEnrollments, index: number) => {
				const {
					plan,
					premiumAmount,
					VEB_primary_beneficiary,
					VEB_contingent_beneficiary,
					totalPremium,
					coverageCode,
					benefitAmount,
					planName,
					subPlan,
					planFor
				} = VEBEnrollment;
				if (planFor?.SSN) {
					const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
						generateWholeLifeActivateVEBEnrollmentPayload(
							plan,
							groupOwner,
							member,
							planFor,
							benefitAmount,
							coverageCode,
							premiumAmount,
							planName,
							totalPremium,
							wholeLifeInsurancePlan.plan_name,
							subPlan,
							VEBOpenEnrollmentId as unknown as string,
							paycheck,
							VEB_primary_beneficiary,
							VEB_contingent_beneficiary,
							writingNumber
						);
					VEBEnrollmentPayload.common_details = VEBEnrollmentCommonDetails;
					VEBEnrollmentPayload.standard_details.push(VEBEnrollmentStandardDetails);
				}
			});
			return VEBEnrollmentPayload;
		},
		[VEBOpenEnrollmentId, groupOwner, hasSelectedRider, member, wholeLifeInsurancePlan.plan_name, writingNumber]
	);

	const waitForModalToClose = () =>
		//eslint-disable-next-line
		new Promise<void>((resolve) => {
			const checkModal = () => {
				if (!isDependentExistsModelOpenRef.current) {
					resolve();
				} else {
					setTimeout(checkModal, 1000);
				}
			};
			checkModal();
		});

	const handleActivateButtonClick = useCallback(async () => {
		const isValid = handleValidation();
		const beneficiaryIsValidation = handleBeneficiaryValidate();
		if (isValid === false || member === null || beneficiaryIsValidation === false) {
			return;
		}
		const spouse = dependentList.filter(
			(dependent, index) => dependent.relationship?.toLocaleUpperCase() === "SPOUSE"
		)[0];
		if (member && coverage_for && memberFaceAmount && VEBOpenEnrollment && paycheck) {
			// Create enrollment for standard plan
			// Member standard plan
			const VEBStandardEnrollments: VEBWholeLifeEnrollments[] = [];
			const coverage_code: CoverageCode =
				spouseFaceAmount && spouseFaceAmount > 0 && childBenefitPlan && childBenefitPlan > 0
					? "EF"
					: spouseFaceAmount && spouseFaceAmount > 0 && !childBenefitPlan
					? "ES"
					: childBenefitPlan && childBenefitPlan > 0 && !spouseFaceAmount
					? "ECH"
					: "EE";

			VEBStandardEnrollments.push({
				plan: wholeLifeInsurancePlan,
				premiumAmount: memberWeeklyPremium,
				totalPremium: Number(totalPremium.toFixed(2)),
				coverageCode: coverage_code,
				benefitAmount: memberFaceAmount,
				planName: "Whole life",
				subPlan: null,
				planFor: member,
				VEB_primary_beneficiary: BV2employeePrimaryBeneficiary,
				VEB_contingent_beneficiary: BV2employeeContingentBeneficiary
			});

			// Spouse standard plan
			if (coverage_for === "Employee & Spouse" && spouseFaceAmount) {
				VEBStandardEnrollments.push({
					plan: wholeLifeInsurancePlan,
					premiumAmount: spouseWeeklyPremium,
					totalPremium: Number(totalPremium.toFixed(2)),
					coverageCode: coverage_code,
					benefitAmount: spouseFaceAmount,
					planName: "Whole life",
					subPlan: null,
					planFor: spouse,
					VEB_primary_beneficiary: BV2spousePrimaryBeneficiary,
					VEB_contingent_beneficiary: BV2spouseContingentBeneficiary
				});
			}

			// Create enrollment for Accidental Death rider plan
			// Member accidental rider plan
			const VEBAccidentRiderEnrollments: VEBWholeLifeEnrollments[] = [];
			if (hasMemberAccidentalDeath && memberAccidentalDeath > 0 && memberFaceAmount) {
				VEBAccidentRiderEnrollments.push({
					plan: wholeLifeInsurancePlan,
					premiumAmount: memberAccidentalDeath,
					totalPremium: memberAccidentalDeath,
					coverageCode: coverage_code,
					benefitAmount: memberFaceAmount,
					planName: "Accidental Death Chronic Illness",
					subPlan: null,
					planFor: member,
					VEB_primary_beneficiary: [],
					VEB_contingent_beneficiary: []
				});
			}

			// Spouse accidental rider plan
			if (hasSpouseAccidentalDeath && spouseFaceAmount) {
				VEBAccidentRiderEnrollments.push({
					plan: wholeLifeInsurancePlan,
					premiumAmount: spouseAccidentalDeath,
					totalPremium: spouseAccidentalDeath,
					coverageCode: coverage_code,
					benefitAmount: spouseFaceAmount,
					planName: "Accidental Death Chronic Illness",
					subPlan: null,
					planFor: spouse,
					VEB_primary_beneficiary: [],
					VEB_contingent_beneficiary: []
				});
			}

			// Create enrollment for waiver rider plan
			// Member waiver rider plan
			const VEBWaiverRiderEnrollments: VEBWholeLifeEnrollments[] = [];
			if (hasMemberWaiverPremium && memberAccidentalDeath > 0 && memberFaceAmount) {
				VEBWaiverRiderEnrollments.push({
					plan: wholeLifeInsurancePlan,
					premiumAmount: memberWaiverPremium,
					totalPremium: memberWaiverPremium,
					coverageCode: coverage_code,
					benefitAmount: memberFaceAmount,
					planName: "Waiver Of Premium",
					subPlan: null,
					planFor: member,
					VEB_primary_beneficiary: [],
					VEB_contingent_beneficiary: []
				});
			}
			if (hasSpouseWaiverPremium && spouseFaceAmount) {
				VEBWaiverRiderEnrollments.push({
					plan: wholeLifeInsurancePlan,
					premiumAmount: spouseWaiverPremium,
					totalPremium: spouseWaiverPremium,
					coverageCode: coverage_code,
					benefitAmount: spouseFaceAmount,
					planName: "Waiver Of Premium",
					subPlan: null,
					planFor: spouse,
					VEB_primary_beneficiary: [],
					VEB_contingent_beneficiary: []
				});
			}

			// Child term rider plan
			const VEBChildRiderEnrollments: VEBWholeLifeEnrollments[] = [];
			if (childBenefitPlan && childBenefitPlan > 0) {
				children.forEach((child, index) => {
					VEBChildRiderEnrollments.push({
						plan: wholeLifeInsurancePlan,
						premiumAmount: childWholeLifePremiumAmount,
						totalPremium: childWholeLifePremiumAmount,
						coverageCode: coverage_code,
						benefitAmount: childBenefitPlan,
						planName: "Child Term",
						subPlan: null,
						planFor: child,
						VEB_primary_beneficiary: BV2childPrimaryBeneficiary,
						VEB_contingent_beneficiary: BV2childContingentBeneficiary
					});
				});
			}

			// // console.log(
			// 	"VEBEnrollments",
			// 	VEBStandardEnrollments,
			// 	VEBAccidentRiderEnrollments,
			// 	VEBWaiverRiderEnrollments
			// );

			const VEBStandardEnrollmentPayload: VEBEnrollmentPayload = generatePayload(
				VEBStandardEnrollments,
				VEBWholeLifeOpenEnrollment,
				paycheck
			);
			const UpdatedVEBEnrollmentPayload = generatePayload(
				VEBStandardEnrollments,
				VEBWholeLifeOpenEnrollment,
				paycheck
			);

			// console.log("VEBSTANDARDPAYLOADCHECK----->>>>>", VEBStandardEnrollmentPayload);
			let premiumAmountToBeRemoved = 0;
			let removedData: any[] = [];
			const childSSNeedToBeRemoved = [];
			// console.log("CONSOLECHECKFORTHECHILDTHING--------->", children);
			//eslint-disable-next-line
			const childrenSSNs = children.map((child) => child.SSN);
			//eslint-disable-next-line
			const childEntries = childrenSSNs.map((ssn) => ({
				member_SSN: ssn,
				member_object_id: "",
				premium_amount: "",
				benefit_amount: "",
				coverage_code: "",
				is_tobacco: "",
				VEB_primary_beneficiary: [],
				VEB_contingent_beneficiary: []
			}));
			UpdatedVEBEnrollmentPayload.standard_details = [
				...(UpdatedVEBEnrollmentPayload.standard_details || []),
				...childEntries
			];
			const existEnrollmentData = await trackPromise(
				api.enrollment.existsVEBEnrollment(UpdatedVEBEnrollmentPayload)
			);
			// console.log("EXISTSSDATA--->", existEnrollmentData)
			if (Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				setIsDependentExistsModelOpen(true);
				// setExistsDependentData(existEnrollmentData[0].member);
				//eslint-disable-next-line
				setExistsDependentData(existEnrollmentData.map((item) => item.member));
				isDependentExistsModelOpenRef.current = true;
				await waitForModalToClose();
			} else {
				setExistsDependentData(null); // Handle empty case
			}
			if (existEnrollmentData && Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				const existingSSNs = existEnrollmentData
					//eslint-disable-next-line
					.map((enrollment) => enrollment?.member?.SSN)
					//eslint-disable-next-line
					.filter((ssn) => ssn); // Filter out undefined or null SSNs
				childSSNeedToBeRemoved.push(existingSSNs);
				if (existingSSNs.length > 0 && VEBStandardEnrollmentPayload.standard_details) {
					removedData = VEBStandardEnrollmentPayload.standard_details.filter((detail: any) =>
						detail.member_SSN.includes("@")
					);
					// console.log("Removed Data:", removedData[0]);
					VEBStandardEnrollmentPayload.standard_details =
						VEBStandardEnrollmentPayload.standard_details.filter(
							(detail: any) =>
								!existingSSNs.includes(detail.member_SSN) && !detail.member_SSN.includes("@")
						);
				}
			}
			if (
				VEBStandardEnrollmentPayload.standard_details &&
				VEBStandardEnrollmentPayload.standard_details.length === 1
			) {
				// let memberInstance;
				for (let i = 0; i < removedData.length; i++) {
					const removedInstanceFromPayload: any = removedData[i];

					const memberInstance = dependentList.find(
						//eslint-disable-next-line
						(memberInstance) => memberInstance.SSN == removedInstanceFromPayload.member_SSN
					);
					if (memberInstance?.relationship === "SPOUSE") {
						premiumAmountToBeRemoved =
							removedInstanceFromPayload.premium_amount + spouseAccidentalDeath + spouseWaiverPremium;
					}
					console.log("removedInstanceFromPayload", removedInstanceFromPayload, memberInstance);
				}
				const total_premium = totalPremium - Number(premiumAmountToBeRemoved.toFixed(2));
				VEBStandardEnrollmentPayload.standard_details[0].premium_amount = total_premium;
				VEBStandardEnrollmentPayload.common_details.total_premium = total_premium;
			}

			console.log("CONSOLEVEBStandardEnrollmentPayload--->", VEBStandardEnrollmentPayload);

			let VEBAccidentalEnrollmentPayload: VEBEnrollmentPayload = {
				isRider: hasSelectedRider ? true : false,
				standard_details: [],
				common_details: {
					agent_id: null,
					location_number: 0,
					location_name: "",
					group_number: 0,
					group_name: "",
					plan_object_id: "",
					plan_code: "",
					plan_name: "",
					base_plan_name: "",
					sub_plan: null,
					insured_object_id: "",
					insured_SSN: "",
					enrollment_status: null,
					unenrolled_reason: null,
					waive_reason: null,
					termination_reason: null,
					writing_number: 0,
					enrollment_date: null,
					effective_date: null,
					termination_date: null,
					open_enrollment_id: null,
					total_premium: 0,
					enrollment_paycheck_id: undefined
				}
			};

			if (VEBAccidentRiderEnrollments.length > 0) {
				VEBAccidentalEnrollmentPayload = generatePayload(
					VEBAccidentRiderEnrollments,
					VEBWholeLifeOpenEnrollment,
					paycheck
				);
			}

			let VEBWaiveEnrollmentPayload: VEBEnrollmentPayload = {
				isRider: hasSelectedRider ? true : false,
				standard_details: [],
				common_details: {
					agent_id: null,
					location_number: 0,
					location_name: "",
					group_number: 0,
					group_name: "",
					plan_object_id: "",
					plan_code: "",
					plan_name: "",
					base_plan_name: "",
					sub_plan: null,
					insured_object_id: "",
					insured_SSN: "",
					enrollment_status: null,
					unenrolled_reason: null,
					waive_reason: null,
					termination_reason: null,
					writing_number: 0,
					enrollment_date: null,
					effective_date: null,
					termination_date: null,
					open_enrollment_id: null,
					total_premium: 0,
					enrollment_paycheck_id: undefined
				}
			};
			if (VEBWaiverRiderEnrollments.length > 0) {
				VEBWaiveEnrollmentPayload = generatePayload(
					VEBWaiverRiderEnrollments,
					VEBWholeLifeOpenEnrollment,
					paycheck
				);
			}

			let VEBChildEnrollmentPayload: VEBEnrollmentPayload = {
				isRider: hasSelectedRider ? true : false,
				standard_details: [],
				common_details: {
					agent_id: null,
					location_number: 0,
					location_name: "",
					group_number: 0,
					group_name: "",
					plan_object_id: "",
					plan_code: "",
					plan_name: "",
					base_plan_name: "",
					sub_plan: null,
					insured_object_id: "",
					insured_SSN: "",
					enrollment_status: null,
					unenrolled_reason: null,
					waive_reason: null,
					termination_reason: null,
					writing_number: 0,
					enrollment_date: null,
					effective_date: null,
					termination_date: null,
					open_enrollment_id: null,
					total_premium: 0,
					enrollment_paycheck_id: undefined
				}
			};

			// console.log("CHECKINGFORTHETHING----->>>>", remainingCount);
			if (VEBChildRiderEnrollments.length > 0) {
				VEBChildEnrollmentPayload = generatePayload(
					VEBChildRiderEnrollments,
					VEBWholeLifeOpenEnrollment,
					paycheck
				);
			}
			const ssnToBeRemoved = childSSNeedToBeRemoved.flat();
			console.log("Flattened SSNs to be removed:", ssnToBeRemoved);
			VEBChildEnrollmentPayload.standard_details = VEBChildEnrollmentPayload.standard_details.filter(
				//eslint-disable-next-line
				(detail) => !ssnToBeRemoved.includes(detail.member_SSN)
			);
			// Update remainingCount to reflect the remaining count
			const remainingCount = VEBChildEnrollmentPayload.standard_details.length;

			const activateStandardEnrollmentPromises: any[] = [];
			const activateRiderAccidentEnrollmentPromises: any[] = [];
			const activateRiderWaiveEnrollmentPromises: any[] = [];
			const activateChildEnrollmentPromises: any[] = [];
			if (remainingCount === 0) {
				VEBChildEnrollmentPayload.common_details.base_plan_name = "";
				VEBStandardEnrollmentPayload.common_details.total_premium = parseFloat(
					(
						VEBStandardEnrollmentPayload.common_details.total_premium -
						VEBChildEnrollmentPayload.common_details.total_premium
					).toFixed(2)
				);
			}
			if (
				VEBStandardEnrollmentPayload.common_details.base_plan_name &&
				VEBAccidentalEnrollmentPayload.common_details.base_plan_name &&
				VEBWaiveEnrollmentPayload.common_details.base_plan_name &&
				VEBChildEnrollmentPayload.common_details.base_plan_name
			) {
				const childTermRiderSSNs: string[] = VEBChildEnrollmentPayload.standard_details.map(
					(standardDetails: VEBEnrollmentStandardDetails) => standardDetails.member_SSN
				);
				//
				const standardResponse = await trackPromise(
					api.enrollment.addVEBEnrollment({ ...VEBStandardEnrollmentPayload, riderSSNs: childTermRiderSSNs })
				);
				console.log("FRIST--->CHECKINGTHISISRUNNINGFORFUCK", standardResponse);
				let childResponse: any = null;
				if (standardResponse) {
					// Extract SSNs to be removed
					console.log("CHECKINGTHISISRUNNINGFORFUCK", standardResponse);
					const ssnToBeRemoved = childSSNeedToBeRemoved.flat(); // Flatten in case it's nested
					console.log("SSNNEEDTOBEREMOVED____________>", ssnToBeRemoved);
					console.log("PAYLOADFORTHECHILF---->", VEBChildEnrollmentPayload);
					VEBChildEnrollmentPayload.standard_details = VEBChildEnrollmentPayload.standard_details.filter(
						//eslint-disable-next-line
						(detail) => !ssnToBeRemoved.includes(detail.member_SSN)
					);
					console.log("UPDATED PAYLOAD AFTER REMOVAL---->", VEBChildEnrollmentPayload);
					childResponse = await trackPromise(api.enrollment.addVEBEnrollment(VEBChildEnrollmentPayload));
				}
				if (standardResponse && childResponse) {
					deleteCurrentEnrollment();
					getVEBEnrollmentInitData();
					const step = urlSearchParams.get("step");
					history.push(`?step=${step}&stage=2`);
				}
			} else if (
				VEBStandardEnrollmentPayload.common_details.base_plan_name &&
				VEBAccidentalEnrollmentPayload.common_details.base_plan_name &&
				VEBWaiveEnrollmentPayload.common_details.base_plan_name &&
				!VEBChildEnrollmentPayload.common_details.base_plan_name
			) {
				console.log("employee + spouse api");
				activateStandardEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBStandardEnrollmentPayload));
				// activateRiderAccidentEnrollmentPromises.push(
				// 	api.enrollment.addVEBEnrollment(VEBAccidentalEnrollmentPayload)
				// );
				// activateRiderWaiveEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBWaiveEnrollmentPayload));
				const standardResponse = await trackPromise(Promise.allSettled(activateStandardEnrollmentPromises));
				// const riderAccidentResponse = await trackPromise(
				// 	Promise.allSettled(activateStandardEnrollmentPromises)
				// );
				// const riderWaiveResponse = await trackPromise(Promise.allSettled(activateStandardEnrollmentPromises));
				if (standardResponse) {
					deleteCurrentEnrollment();
					getVEBEnrollmentInitData();
					const step = urlSearchParams.get("step");
					history.push(`?step=${step}&stage=2`);
				}
			} else if (
				VEBStandardEnrollmentPayload.common_details.base_plan_name &&
				VEBAccidentalEnrollmentPayload.common_details.base_plan_name &&
				!VEBWaiveEnrollmentPayload.common_details.base_plan_name &&
				!VEBChildEnrollmentPayload.common_details.base_plan_name
			) {
				activateStandardEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBStandardEnrollmentPayload));
				// activateRiderAccidentEnrollmentPromises.push(
				// 	api.enrollment.addVEBEnrollment(VEBAccidentalEnrollmentPayload)
				// );
				const standardResponse = await trackPromise(Promise.allSettled(activateStandardEnrollmentPromises));
				//let riderAccidentResponse: any = null;
				// if (standardResponse) {
				// 	riderAccidentResponse = await trackPromise(Promise.allSettled(activateStandardEnrollmentPromises));
				// }

				if (standardResponse) {
					deleteCurrentEnrollment();
					getVEBEnrollmentInitData();
					const step = urlSearchParams.get("step");
					history.push(`?step=${step}&stage=2`);
				}
			} else if (
				VEBStandardEnrollmentPayload.common_details.base_plan_name &&
				!VEBAccidentalEnrollmentPayload.common_details.base_plan_name &&
				!VEBWaiveEnrollmentPayload.common_details.base_plan_name &&
				!VEBChildEnrollmentPayload.common_details.base_plan_name
			) {
				activateStandardEnrollmentPromises.push(api.enrollment.addVEBEnrollment(VEBStandardEnrollmentPayload));
				const standardResponse = await trackPromise(Promise.allSettled(activateStandardEnrollmentPromises));
				if (standardResponse) {
					deleteCurrentEnrollment();
					getVEBEnrollmentInitData();
					const step = urlSearchParams.get("step");
					history.push(`?step=${step}&stage=2`);
				}
			}
		}
	}, [
		handleValidation,
		handleBeneficiaryValidate,
		member,
		dependentList,
		coverage_for,
		memberFaceAmount,
		VEBOpenEnrollment,
		paycheck,
		spouseFaceAmount,
		childBenefitPlan,
		wholeLifeInsurancePlan,
		memberWeeklyPremium,
		totalPremium,
		BV2employeePrimaryBeneficiary,
		BV2employeeContingentBeneficiary,
		hasMemberAccidentalDeath,
		memberAccidentalDeath,
		hasSpouseAccidentalDeath,
		hasMemberWaiverPremium,
		hasSpouseWaiverPremium,
		generatePayload,
		VEBWholeLifeOpenEnrollment,
		hasSelectedRider,
		spouseWeeklyPremium,
		BV2spousePrimaryBeneficiary,
		BV2spouseContingentBeneficiary,
		spouseAccidentalDeath,
		memberWaiverPremium,
		spouseWaiverPremium,
		children,
		childWholeLifePremiumAmount,
		BV2childPrimaryBeneficiary,
		BV2childContingentBeneficiary,
		deleteCurrentEnrollment,
		getVEBEnrollmentInitData,
		urlSearchParams,
		history
	]);
	useEffect(() => {
		isDependentExistsModelOpenRef.current = isDependentExistsModelOpen;
	}, [isDependentExistsModelOpen]);
	const handleWaiveButtonClick = useCallback((): void => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const handleOpenDisclaimerDialogClick = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: true }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleCloseDisclaimerDialog = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleEscapeCloseDisclaimerDialog = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			const Key = event.key;

			if (Key === "Escape")
				setEnrollmentDisclaimerDialogProps(
					Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
				);
		},
		[enrollmentDisclaimerDialogProps]
	);

	const handleClose = () => {
		setModalOpen(false);
		setEditData(null);
	};

	const calculateAgeFromDOB = (date_of_birth: string | number | Date) => {
		const dob = new Date(date_of_birth);
		const ageDifMs =
			new Date(VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD).getTime() -
			dob.getTime();
		const ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	};

	// console.log("paycheck", paycheck);
	// console.log(coverage_for);

	useEffect(() => {
		const spouseDetails = dependents.find((dependent, index) => dependent.relationship === "SPOUSE");
		if (spouseDetails) {
			setSpouse(spouseDetails);
		}
	}, [dependents]);

	useEffect(() => {
		if (member) {
			let premiumAmount = 0;
			let deathChronicIllness = 0;
			let waiverOfPremium = 0;
			let spousePrimiumAmount = 0;
			let spouseDeathChronicIllness = 0;
			let spouseWaiverOfPremium = 0;
			const spouseDetails = dependents.find((dependent, index) => dependent.relationship === "SPOUSE");
			if (spouseDetails) {
				setSpouse(spouseDetails);
			}
			const { is_tobacco, date_of_birth } = member;
			const tobacco = is_tobacco === true ? "smoker" : "non_smoker";
			setSmoker(tobacco);
			const dob = typeof date_of_birth === "string" ? new Date(date_of_birth) : new Date();
			const ageDifMs =
				new Date(VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD).getTime() -
				dob.getTime();
			const ageDate = new Date(ageDifMs);
			const calculate_age = Math.abs(ageDate.getUTCFullYear() - 1970);
			setAge(calculate_age);
			//const calculate_age = 18;
			//setAge(18);
			const ECHRelationship = ["SON", "CHILD", "DAUGHTER", "STEP CHILD"];
			const children = dependents.filter((child, index) => {
				const relationship = child.relationship !== null ? child.relationship : "";
				if (ECHRelationship.includes(relationship)) {
					const childDOB: Date =
						child.date_of_birth === undefined ? new Date() : new Date(child.date_of_birth);
					const age = calculateAgeFromDOB(childDOB);
					if (getAgeInDays(child.date_of_birth) >= 30 && age < 26) {
						return child;
					}
				}
			});
			setChildren(children);
			if (paycheck && coverage_for !== "" && memberFaceAmount !== null) {
				// console.log("calculate_age.toString()", calculate_age.toString());
				// console.log(
				// 	"wholeLifePlan.premium_amount [tobacco as keyof WholeLifePremiumAmount]",
				// 	wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount]
				// );
				// // console.log(
				// 	"wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][calculate_age.toString() as keyof WholeLifeAge]",
				// 	wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
				// 		calculate_age.toString() as keyof WholeLifeAge
				// 	]
				// );
				premiumAmount =
					wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
						calculate_age.toString() as keyof WholeLifeAge
					]["standard_premium" as keyof WholeLifeStandardPremiumAmount][
						coverage_for as keyof WholeLifePlanCoverage
					][memberFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
						paycheck.pay_frequency as keyof PaycheckFrequency
					] || 0;
				deathChronicIllness =
					wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
						calculate_age.toString() as keyof WholeLifeAge
					]["rider_chronicle_illness" as keyof WholeLifeStandardPremiumAmount][
						coverage_for as keyof WholeLifePlanCoverage
					][memberFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
						paycheck.pay_frequency as keyof PaycheckFrequency
					] || 0;
				if (hasMemberWaiverPremium === true) {
					// console.log("calculate_age", calculate_age);
					// console.log("paycheck.pay_frequency", paycheck.pay_frequency);
					waiverOfPremium =
						wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
							calculate_age.toString() as keyof WholeLifeAge
						]["rider_waiver_premium" as keyof WholeLifeStandardPremiumAmount][
							coverage_for as keyof WholeLifePlanCoverage
						][memberFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
							paycheck.pay_frequency as keyof PaycheckFrequency
						] || 0;

					// console.log("waiverOfPremium", waiverOfPremium);
				}

				setmemberWeeklyPremium(premiumAmount);
				setmemberAccidentalDeath(deathChronicIllness);
				setmemberWaiverPremium(waiverOfPremium);
				// // console.log(
				// 	"GG: deathChronicIllness",
				// 	wholeLifePlan.premium_amount[tobacco as keyof WholeLifePremiumAmount][
				// 		calculate_age.toString() as keyof WholeLifeAge
				// 	]["rider_chronicle_illness" as keyof WholeLifeStandardPremiumAmount][
				// 		coverage_for as keyof WholeLifePlanCoverage
				// 	][memberFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
				// 		paycheck.pay_frequency as keyof PaycheckFrequency
				// 	]
				// );
			}
			if (paycheck && coverage_for !== "" && spouseFaceAmount !== null) {
				if (dependents.find((val, index) => val.relationship === "SPOUSE")) {
					const dep_is_tobacco = dependents.find((val, index) => val.relationship === "SPOUSE")?.is_tobacco;
					const dep_date_of_birth = dependents.find(
						(val, index) => val.relationship === "SPOUSE"
					)?.date_of_birth;
					const tobacco_dep = dep_is_tobacco === true ? "smoker" : "non_smoker";
					const dob_dep = dep_date_of_birth === undefined ? new Date() : new Date(dep_date_of_birth);
					const ageDifMs_dep = Date.now() - dob_dep.getTime();
					const ageDate_dep = new Date(ageDifMs_dep);
					const calculate_age_dep = Math.abs(ageDate_dep.getUTCFullYear() - 1970);
					//const calculate_age_dep = 18;
					spousePrimiumAmount =
						wholeLifePlan.premium_amount[tobacco_dep as keyof WholeLifePremiumAmount][
							calculate_age_dep.toString() as keyof WholeLifeAge
						]["standard_premium" as keyof WholeLifeStandardPremiumAmount][
							coverage_for as keyof WholeLifePlanCoverage
						][spouseFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
							paycheck.pay_frequency as keyof PaycheckFrequency
						] || 0;
					spouseDeathChronicIllness =
						wholeLifePlan.premium_amount[tobacco_dep as keyof WholeLifePremiumAmount][
							calculate_age_dep.toString() as keyof WholeLifeAge
						]["rider_chronicle_illness" as keyof WholeLifeStandardPremiumAmount][
							coverage_for as keyof WholeLifePlanCoverage
						][spouseFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
							paycheck.pay_frequency as keyof PaycheckFrequency
						] || 0;
					if (hasSpouseWaiverPremium) {
						spouseWaiverOfPremium =
							wholeLifePlan.premium_amount[tobacco_dep as keyof WholeLifePremiumAmount][
								calculate_age_dep.toString() as keyof WholeLifeAge
							]["rider_waiver_premium" as keyof WholeLifeStandardPremiumAmount][
								coverage_for as keyof WholeLifePlanCoverage
							][spouseFaceAmount.toString() as keyof WholeLifeFaceAmountFrequency][
								paycheck.pay_frequency as keyof PaycheckFrequency
							] || 0;
					}

					setspouseWeeklyPremium(spousePrimiumAmount === undefined ? 0 : spousePrimiumAmount);
					setspouseAccidentalDeath(spouseDeathChronicIllness === undefined ? 0 : spouseDeathChronicIllness);
					setspouseWaiverPremium(spouseWaiverOfPremium === undefined ? 0 : spouseWaiverOfPremium);
				}
			}
			const children_benefit_amount =
				childBenefitPlan && childBenefitPlan > 0
					? wholeLifeChildPlan.premium_amount[
							childBenefitPlan?.toString() as keyof WholeLifeChildPremiumAmount
					  ][paycheck?.pay_frequency as keyof PaycheckFrequency]
					: 0;
			setChildWholeLifePremiumAmount(children_benefit_amount ? children_benefit_amount : 0);
			// console.log("B: premiumAmount", premiumAmount);
			// console.log("B: childWholeLifePremiumAmount", childWholeLifePremiumAmount);

			// console.log("B: waiverOfPremium", waiverOfPremium);
			// console.log("B: spousePrimiumAmount", spousePrimiumAmount);
			// console.log("B: spouseDeathChronicIllness", spouseDeathChronicIllness);
			// console.log("B: spouseWaiverOfPremium", spouseWaiverOfPremium);
			const total_premium =
				premiumAmount +
				childWholeLifePremiumAmount +
				(hasMemberAccidentalDeath === true ? deathChronicIllness : 0) +
				(hasMemberWaiverPremium ? waiverOfPremium : 0) +
				spousePrimiumAmount +
				(hasSpouseAccidentalDeath === true ? spouseDeathChronicIllness : 0) +
				(hasSpouseWaiverPremium === true ? spouseWaiverOfPremium : 0);
			setTotalPremium(Number(total_premium.toFixed(2)));
			setCurrentEnrollment(
				Object.assign(
					{},
					{
						plan_name: "Whole life",
						status: "Current",
						premium_amount: Number(total_premium.toFixed(2))
					}
				)
			);
		}
	}, [
		age,
		dependentList,
		coverage_for,
		dependents,
		hasMemberAccidentalDeath,
		hasMemberWaiverPremium,
		hasSpouseAccidentalDeath,
		hasSpouseWaiverPremium,
		member,
		memberFaceAmount,
		paycheck,
		spouseFaceAmount,
		wholeLifePlan.premium_amount,
		childBenefitPlan,
		childWholeLifePremiumAmount,
		wholeLifeChildPlan.premium_amount,
		setCurrentEnrollment
	]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	useEffect(() => {
		const dependentCoverage = getKemperWholeLifeEligibleDependents(dependents);
		seWholeLifePlan((prevWholeLifePlanDetails: WholeLifePlanDetails) => {
			return Object.assign({}, prevWholeLifePlanDetails, {
				coverage: dependentCoverage.coverage
			});
		});
		if (member === null) {
			return;
		}
		const childrenPrimaryBeneficiary: BV2Beneficiery = {
			first_name: member.first_name + member.last_name,
			middle_name: member.middle_name ? member.middle_name : "",
			last_name: member.last_name,
			type: "PRIMARY",
			insured_SSN: member.SSN,
			relationship: null,
			address_line_1: member.address_line_1,
			address_line_2: member.address_line_2,
			state: member.state,
			ZIP: member.ZIP,
			SSN: "",
			date_of_birth: member.date_of_birth,
			gender: member.gender,
			percentage: 100,
			phone_number: member.phone_number
		};
		setBV2ChildPrimaryBeneficiary(Object.assign([], [childrenPrimaryBeneficiary]));
	}, [dependents, member]);

	useEffect(() => {
		if (dependents) {
			const dependentCoverage = getKemperWholeLifeEligibleDependentsV2(dependents);
			if (hasOpenedEligiblity === false) {
				setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
					return Object.assign({}, prevEligiblityDialogProps, {
						openDialog: true,
						eligibleDependents: Object.assign([], dependentCoverage.dependents),
						ineligibleRelationshipDependents: Object.assign(
							[],
							dependentCoverage.ineligibleRelationshipDependents
						),
						ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
					});
				});
				setHasOpenedEligiblity(true);
			}

			const spouse = dependentCoverage.dependents.find(
				(dependent: Member) => dependent.relationship === "SPOUSE"
			);
			if (spouse) {
				const spouseAge = calculateAge(
					spouse.date_of_birth,
					VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
				);
				if (spouseAge > 60) {
					setHasSpouseWaiverPremium(false);
				}
			}
			if (member) {
				const memberAge = calculateAge(
					member.date_of_birth,
					VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
				);
				if (memberAge > 60) {
					setHasMemberWaiverPremium(false);
				}
			}
			setEligiblity(
				Object.assign(
					{},
					{
						eligibleDependents: Object.assign([], dependentCoverage.dependents),
						ineligibleRelationshipDependents: Object.assign(
							[],
							dependentCoverage.ineligibleRelationshipDependents
						),
						ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
					}
				)
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dependents, setEligiblity, member]);

	const setBeneficiaries = useCallback(() => {
		if (member === null) {
			return;
		}
		if (spouse) {
			const newPrimaryBeneficiary: BV2Beneficiery = {
				first_name: spouse.first_name,
				middle_name: spouse.middle_name ? spouse.middle_name : "",
				last_name: spouse.last_name,
				type: "PRIMARY",
				insured_SSN: member.SSN,
				relationship: spouse.relationship,
				address_line_1: spouse.address_line_1,
				address_line_2: spouse.address_line_2,
				state: spouse.state,
				ZIP: spouse.ZIP,
				SSN: spouse.SSN,
				date_of_birth: dateTimeZoneConverter(spouse.date_of_birth as string) as unknown as string,
				gender: spouse.gender,
				percentage: 100,
				phone_number: spouse.phone_number
			};
			setBV2EmployeePrimaryBeneficiary(Object.assign([], [newPrimaryBeneficiary]));
		}
		if (coverage_for === "Employee & Spouse" || coverage_for === "Employee & Family") {
			const newPrimaryBeneficiary: BV2Beneficiery = {
				first_name: member.first_name,
				middle_name: member.middle_name ? member.middle_name : "",
				last_name: member.last_name,
				type: "PRIMARY",
				insured_SSN: member.SSN,
				relationship: null,
				address_line_1: member.address_line_1,
				address_line_2: member.address_line_2,
				state: member.state,
				ZIP: member.ZIP,
				SSN: member.SSN,
				date_of_birth: dateTimeZoneConverter(member.date_of_birth as string) as unknown as string,
				gender: member.gender,
				percentage: 100,
				phone_number: member.phone_number
			};
			setBV2SpousePrimaryBeneficiary(Object.assign([], [newPrimaryBeneficiary]));
		}
		if (childBenefitPlan && childBenefitPlan > 0) {
			const newPrimaryBeneficiary: BV2Beneficiery = {
				first_name: member.first_name,
				middle_name: member.middle_name ? member.middle_name : "",
				last_name: member.last_name,
				type: "PRIMARY",
				insured_SSN: member.SSN,
				relationship: member.relationship,
				address_line_1: member.address_line_1,
				address_line_2: member.address_line_2,
				state: member.state,
				ZIP: member.ZIP,
				SSN: member.SSN,
				date_of_birth: dateTimeZoneConverter(member.date_of_birth as string) as unknown as string,
				gender: member.gender,
				percentage: 100,
				phone_number: member.phone_number
			};
			setBV2ChildPrimaryBeneficiary(Object.assign([], [newPrimaryBeneficiary]));
		}
	}, [childBenefitPlan, coverage_for, member, spouse]);

	useEffect(() => {
		if (coverage_for === "" && childBenefitPlan === 0) {
			return;
		}
		setBeneficiaries();
	}, [setBeneficiaries, coverage_for, childBenefitPlan]);

	// useEffect(() => {
	// 	let primaryMemberBeneficiaryCount = 0;
	// 	let primaryMemberBeneficiaryPercentage = 0;
	// 	let primarySpouseBeneficiaryCount = 0;
	// 	let primarySpouseBeneficiaryPercentage = 0;
	// 	let contingentMemberBeneficiaryCount = 0;
	// 	let contingentMemberBeneficiaryPercentage = 0;
	// 	let contingentSpouserBeneficiaryCount = 0;
	// 	let contingentSpouseBeneficiaryPercentage = 0;
	// 	if (selectCard === "member-card") {
	// 		[...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].forEach(
	// 			(element: Beneficiary, index: number) => {
	// 				if (element.type === "PRIMARY") {
	// 					primaryMemberBeneficiaryPercentage = primaryMemberBeneficiaryPercentage + element.percentage;
	// 					primaryMemberBeneficiaryCount = primaryMemberBeneficiaryCount + 1;
	// 				}
	// 				if (element.type === "CONTINGENT") {
	// 					contingentMemberBeneficiaryCount = contingentMemberBeneficiaryCount + 1;
	// 					contingentMemberBeneficiaryPercentage =
	// 						contingentMemberBeneficiaryPercentage + element.percentage;
	// 				}
	// 			}
	// 		);
	// 		setPrimaryMemberBeneficiary(
	// 			Object.assign({}, primaryMemberBeneficiary, {
	// 				percentage: primaryMemberBeneficiaryPercentage,
	// 				count: primaryMemberBeneficiaryCount
	// 			})
	// 		);
	// 		setContingentMemberBeneficiary(
	// 			Object.assign({}, contingentMemberBeneficiary, {
	// 				percentage: contingentMemberBeneficiaryPercentage,
	// 				count: contingentMemberBeneficiaryCount
	// 			})
	// 		);
	// 	} else {
	// 		if (selectCard === "spouse-card") {
	// 			[...addSpousePrimaryBeneficiary, ...addSpouseContigentBeneficiary].forEach(
	// 				(element: Beneficiary, index: number) => {
	// 					if (element.type === "PRIMARY") {
	// 						primarySpouseBeneficiaryPercentage =
	// 							primarySpouseBeneficiaryPercentage + element.percentage;
	// 						primarySpouseBeneficiaryCount = primarySpouseBeneficiaryCount + 1;
	// 					}
	// 					if (element.type === "CONTINGENT") {
	// 						contingentSpouseBeneficiaryPercentage =
	// 							contingentSpouseBeneficiaryPercentage + element.percentage;
	// 						contingentSpouserBeneficiaryCount = contingentSpouserBeneficiaryCount + 1;
	// 					}
	// 				}
	// 			);
	// 			setPrimarySpouseBeneficiary(
	// 				Object.assign({}, primarySpouseBeneficiary, {
	// 					percentage: primarySpouseBeneficiaryPercentage,
	// 					count: primarySpouseBeneficiaryCount
	// 				})
	// 			);
	// 			setContingentSpouseBeneficiary(
	// 				Object.assign({}, contingentSpouseBeneficiary, {
	// 					percentage: contingentSpouseBeneficiaryPercentage,
	// 					count: contingentSpouserBeneficiaryCount
	// 				})
	// 			);
	// 		}
	// 	}
	// }, [
	// 	addSpousePrimaryBeneficiary,
	// 	addSpouseContigentBeneficiary,
	// 	addMemberPrimaryBeneficiary,
	// 	addMemberContigentBeneficiary,
	// 	selectCard
	// ]);
	// console.log("sdsd");

	return (
		<>
			<Suspense fallback={<div />}>
				<Suspense fallback={<div />}>
					<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
				</Suspense>
				<Suspense fallback={<div />}>
					<CustomEnrollmentDisclaimerDialog
						enrollmentDisclaimerDialogProps={enrollmentDisclaimerDialogProps}
						handleCloseDisclaimerDialog={handleCloseDisclaimerDialog}
						handleEscapeCloseDisclaimerDialog={handleEscapeCloseDisclaimerDialog}
						emailDisclaimer={emailDisclaimer}
						setEmailDisclaimer={setEmailDisclaimer}
					/>
				</Suspense>
				<Suspense fallback={<div />}>
					{customFormDialogProps ? (
						<LazyCustomFormDialog customFormDialogProps={customFormDialogProps} />
					) : null}
				</Suspense>
				<div className="kemper-cancer-form plan-form">
					<div className="paper-form-container">
						<Paper className="theme-border-radius paper-container" elevation={1}>
							<VEBPlanHeader
								planName="MedMutual Protect Group Whole Life Insurance Policy"
								effectiveDate={
									planCode
										? planCode === "WL-ALL-2024"
											? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY
											: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_MMDDYYYY
										: "N/A"
								}
								planCode={planCode ? (planCode as unknown as string) : "No Plan is Opened"}
							/>
							<div className="plan-content">
								<div className="theme-plan-section-margin" />
								<div className="header-container header-container-new">
									<div className="theme-plan-header">
										Standard Benefits({member.first_name} {member.last_name})
										<span className="smoker-flag-set-area">
											<span className="is-smoker-label">
												Used nicotine or tobacco products in the last 5 years?
											</span>
											<label className="switch">
												<input
													type="checkbox"
													name="member-tobacco"
													checked={member?.is_tobacco}
													onChange={hableTobaccoToggle}
												/>
												<span className="slider round"></span>
											</label>
										</span>
									</div>
								</div>
								<div>
									<div
										className="theme-plan-sub-header plan-text"
										style={{ borderLeftColor: theme.primary_color }}
									>
										In addition to yourself, who would you like to cover under this plan?
									</div>
									<Grid className="grid-container" container columnSpacing={2}>
										<Grid container columnSpacing={2}>
											<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
												<div className="details-form-row">
													<div className="details-form-label  required">Coverage For</div>
													<Select
														input={<CustomSelectInput />}
														style={{ width: "100%" }}
														name="contact_label"
														onChange={(event: any) => handleCoverageChange(event)}
													>
														{wholeLifePlan.coverage.map((option: string, index: number) => {
															{
																if (
																	option === "Employee Only" ||
																	option === "Employee & Spouse"
																) {
																	return (
																		<MenuItem value={option} key={index}>
																			{option}
																		</MenuItem>
																	);
																}
															}
														})}
													</Select>
												</div>
											</Grid>
											<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
												<div className="details-form-row">
													<div className="details-form-label  required">Face Amount</div>
													<Select
														input={<CustomSelectInput />}
														style={{ width: "100%" }}
														name="member_face_amount"
														onChange={(event: SelectChangeEvent) => handlePlanChange(event)}
													>
														{wholeLifePlan.coverage_level.map((coverage, index) => {
															return (
																// eslint-disable-next-line react/jsx-key
																<MenuItem value={coverage === null ? "" : coverage}>
																	{coverage === null ? "Select" : coverage}
																</MenuItem>
															);
														})}
													</Select>
												</div>
											</Grid>
											<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
												<div className="details-form-row">
													<div className="details-form-label required align-center">
														Premium
													</div>
													<div className="show-premium">
														<div className="show-premium">
															{memberWeeklyPremium == 0
																? "$0.00"
																: `$${
																		memberWeeklyPremium &&
																		memberWeeklyPremium.toFixed(2)
																  }`}
														</div>
													</div>
												</div>
											</Grid>
										</Grid>
										<Grid container columnSpacing={2}>
											<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
												<div style={{ display: "flex" }} className="margin-top-10">
													<Checkbox
														checked={hasMemberAccidentalDeath}
														style={{ paddingLeft: 0 }}
														onChange={handleChronicIllnessChange}
														name="member-death-chronic-illness"
														className="margin-fix"
														disabled={true}
													/>
													<div className="checkbox-label details-form-row">
														<div className="details-form-label">
															Accidental Death Chronic illness
														</div>
													</div>
												</div>
											</Grid>
											<Grid item xl={5} lg={5} md={5} sm={5} xs={6}></Grid>
											<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
												<div className="details-form-row">
													{hasMemberAccidentalDeath && (
														<div className="show-premium">
															{memberAccidentalDeath == 0
																? "$0.00"
																: `$${
																		memberAccidentalDeath &&
																		memberAccidentalDeath.toFixed(2)
																  }`}
														</div>
													)}
												</div>
											</Grid>
										</Grid>
										<Grid container columnSpacing={2}>
											<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
												<div style={{ display: "flex" }}>
													<Checkbox
														checked={hasMemberWaiverPremium}
														style={{ paddingLeft: 0 }}
														onChange={handleWaiverPremiumChange}
														name="member-waiver-premium"
														className="margin-fix"
														disabled={true}
													/>
													<div className="checkbox-label details-form-row">
														<div className="details-form-label">Wavier Of Premium</div>
													</div>
												</div>
											</Grid>
											<Grid item xl={5} lg={5} md={5} sm={5} xs={6}></Grid>
											<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
												<div className="details-form-row margin-top-minus-8">
													{hasMemberWaiverPremium && (
														<div className="show-premium">
															{memberWaiverPremium == 0
																? "$0.00"
																: `$${
																		memberWaiverPremium &&
																		memberWaiverPremium.toFixed(2)
																  }`}
														</div>
													)}
												</div>
											</Grid>
										</Grid>
									</Grid>
								</div>
							</div>
							{/* Spouse */}
							{dependentList.length > 0 &&
								dependentList.map((dependent: any, index: number) => {
									return (
										<div key={index}>
											<div
												className={
													coverage_for === "Employee Only" || coverage_for === ""
														? "hidden"
														: "header-container header-container-new margin-top-20"
												}
											>
												<div className="theme-plan-header">
													{dependent?.relationship}({dependent?.first_name}{" "}
													{dependent?.last_name})
													<span className="smoker-flag-set-area">
														<span className="is-smoker-label">
															Used nicotine or tobacco products in the last 5 years?
														</span>
														<label className="switch">
															<input
																type="checkbox"
																checked={dependent?.is_tobacco}
																onChange={hableTobaccoToggle}
																name="spouse-tobacco"
															/>
															<span className="slider round"></span>
														</label>
													</span>
												</div>
											</div>
											<Grid
												className={
													coverage_for === "Employee Only" || coverage_for === ""
														? "hidden"
														: "grid-container member-grid"
												}
												container
												columnSpacing={2}
											>
												<Grid container columnSpacing={2}>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
														<div className="details-form-row">
															<div className="details-form-label  required">
																Face Amount
															</div>
															<Select
																input={<CustomSelectInput />}
																style={{ width: "100%" }}
																name="spouse_face_amount"
																onChange={(event: SelectChangeEvent) =>
																	handlePlanChange(event)
																}
															>
																{dependent?.relationship.toLocaleUpperCase() ===
																	"SPOUSE" &&
																	wholeLifePlan.coverage_level
																		.filter(
																			(item, index) =>
																				item &&
																				item <= Number(memberFaceAmount) &&
																				item <= 50000
																		)
																		.map((coverage, index) => {
																			return (
																				// eslint-disable-next-line react/jsx-key
																				<MenuItem
																					value={
																						coverage === null
																							? ""
																							: coverage.toString()
																					}
																				>
																					{coverage === null
																						? "Select"
																						: coverage}
																				</MenuItem>
																			);
																		})}
																{/* {dependent?.relationship.toLocaleUpperCase() !== "SPOUSE" &&
																wholeLifePlan.coverage_level.map((coverage, index) => {
																	return (
																		// eslint-disable-next-line react/jsx-key
																		<MenuItem value={coverage ? coverage : ""}>
																			{coverage ? coverage : "Select"}
																		</MenuItem>
																	);
																})} */}
															</Select>
														</div>
													</Grid>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={6}></Grid>
													<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
														<div className="details-form-row">
															<div className="details-form-label required align-center">
																Premium
															</div>
															<div className="show-premium">
																<div className="show-premium">
																	{spouseWeeklyPremium == 0
																		? "$0.00"
																		: `$${
																				spouseWeeklyPremium &&
																				spouseWeeklyPremium.toFixed(2)
																		  }`}
																</div>
															</div>
														</div>
													</Grid>
												</Grid>
												<Grid container columnSpacing={2}>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
														<div style={{ display: "flex" }} className="margin-top-10">
															<Checkbox
																checked={hasSpouseAccidentalDeath}
																style={{ paddingLeft: 0 }}
																onChange={handleChronicIllnessChange}
																name="spouse-death-chronic-illness"
																className="margin-fix"
																disabled={true}
															/>
															<div className="checkbox-label details-form-row">
																<div className="details-form-label">
																	Accidental Death Chronic illness
																</div>
															</div>
														</div>
													</Grid>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={6}></Grid>
													<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
														<div className="details-form-row">
															{hasSpouseAccidentalDeath && (
																<div className="show-premium">
																	{spouseAccidentalDeath == 0
																		? "$0.00"
																		: `$${
																				hasSpouseAccidentalDeath &&
																				spouseAccidentalDeath.toFixed(2)
																		  }`}
																</div>
															)}
														</div>
													</Grid>
												</Grid>
												<Grid container columnSpacing={2}>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
														<div style={{ display: "flex" }}>
															<Checkbox
																checked={hasSpouseWaiverPremium}
																style={{ paddingLeft: 0 }}
																onChange={handleWaiverPremiumChange}
																name="spouse-waiver-premium"
																className="margin-fix"
																disabled={true}
															/>
															<div className="checkbox-label details-form-row">
																<div className="details-form-label">
																	Wavier Of Premium
																</div>
															</div>
														</div>
													</Grid>
													<Grid item xl={5} lg={5} md={5} sm={5} xs={6}></Grid>
													<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
														<div className="details-form-row margin-top-minus-8">
															{hasSpouseWaiverPremium && (
																<div className="show-premium">
																	{spouseWaiverPremium == 0
																		? "$0.00"
																		: `$${
																				spouseWaiverPremium &&
																				spouseWaiverPremium.toFixed(2)
																		  }`}
																</div>
															)}
														</div>
													</Grid>
												</Grid>
											</Grid>
										</div>
									);
								})}

							{/* End Spouse */}

							{/* Child */}
							<div className={children && children.length > 0 ? "" : "disable-child"}>
								<span className="tooltip-text">No child has been registered to avail this plan</span>
								<div className="header-container-new margin-top-20">
									<div className="theme-plan-header">
										Child Term Life Insurance {children && children.length > 0 ? "(" : null}
										{children.map((child: Member, index: number) => {
											return (
												<span key={index}>
													{child?.first_name} {child?.last_name}
													{index + 1 === children.length ? "" : ", "}
												</span>
											);
										})}
										{children && children.length > 0 ? ")" : null}
									</div>
								</div>
								<Grid className="grid-container" container columnSpacing={2}>
									<Grid container columnSpacing={2}>
										<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
											<div className="details-form-row">
												<div className="details-form-label">Benefit Amount</div>
												<Select
													input={<CustomSelectInput />}
													style={{ width: "100%" }}
													name="children_benefit_plan"
													disabled={children && children.length > 0 ? false : true}
													onChange={(event: SelectChangeEvent) =>
														handleChildrenBenefitAmount(event)
													}
												>
													{wholeLifeChildPlan.coverage_level.map(
														(option: any, index: number) => {
															return (
																<MenuItem value={option ? option : ""} key={index}>
																	{option ? option : "Select"}
																</MenuItem>
															);
														}
													)}
												</Select>
											</div>
										</Grid>
										<Grid item xl={5} lg={5} md={5} sm={5} xs={6}></Grid>
										<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
											<div className="details-form-row">
												<div className="details-form-label required align-center">Premium</div>
												<div className="show-premium">
													<div className="show-premium">
														{childWholeLifePremiumAmount == 0
															? "$0.00"
															: `$${
																	childWholeLifePremiumAmount &&
																	childWholeLifePremiumAmount.toFixed(2)
															  }`}
													</div>
												</div>
											</div>
										</Grid>
									</Grid>
								</Grid>
							</div>

							{/* End Child */}
							<div className="theme-plan-inner-section-margin-2" />
							<Grid container className="theme-plan-inner-section-margin">
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
									<div className="details-form-row">
										<div
											className="details-form-label theme-plan-total-premium align-right"
											style={{ color: theme.primary_color }}
										>
											Total Premium:{" "}
											<span className="show-premium margin-adjust">
												{totalPremium == 0
													? "$0.00"
													: `$${totalPremium && totalPremium.toFixed(2)}`}
											</span>
										</div>
									</div>
								</Grid>
							</Grid>

							{/* <Grid item xl={2} lg={2} md={2} sm={6} xs={6} className="amount-middle">
									<div className="details-form-row">
										<div className="details-form-label required align-center">Premium</div>
										<div className="show-premium">
											{premium_amount == 0 ? "" : `$${premium_amount.toFixed(2)}`}
										</div>
									</div>
								</Grid> */}
							<div className="accordion-container">
								<Accordion
									expanded={expanded_panel === "panel_beneficiary"}
									onChange={handleBeneficiaryChange("panel_beneficiary")}
								>
									<AccordionSummary aria-controls="panel1d-content" id="panel-header-beneficiary">
										<Typography>Add Beneficiary</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<Grid
											container
											justifyContent={"center"}
											justifyItems="center"
											alignItems={"center"}
										>
											{member &&
											(coverage_for === "Employee Only" ||
												coverage_for === "Employee & Children" ||
												coverage_for === "Employee & Spouse" ||
												coverage_for === "Employee & Family") ? (
												<Grid item xl={12} lg={12} md={12}>
													<VEBBeneficiary
														primaryBeneficiary={BV2employeePrimaryBeneficiary}
														setPrimaryBeneficiary={setBV2EmployeePrimaryBeneficiary}
														contingentBeneficiary={BV2employeeContingentBeneficiary}
														setContingentBeneficiary={setBV2EmployeeContingentBeneficiary}
														member={member}
														employee={member}
														dependents={dependents}
													/>
												</Grid>
											) : null}
											{spouse &&
											(coverage_for === "Employee & Spouse" ||
												coverage_for === "Spouse Only" ||
												coverage_for === "Spouse & Children" ||
												coverage_for === "Employee & Family") ? (
												<Grid item xl={12} lg={12} md={12}>
													<div className="theme-plan-section-margin" />
													<VEBBeneficiary
														primaryBeneficiary={BV2spousePrimaryBeneficiary}
														setPrimaryBeneficiary={setBV2SpousePrimaryBeneficiary}
														contingentBeneficiary={BV2spouseContingentBeneficiary}
														setContingentBeneficiary={setBV2SpouseContingentBeneficiary}
														member={spouse}
														employee={member}
														dependents={dependents}
													/>
												</Grid>
											) : null}
										</Grid>
									</AccordionDetails>
									{/* <AccordionDetails>
									<Grid container className="card-grid-container">
										{coverage_for === "Employee Only" && memberFaceAmount !== null ? (
											<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
												<VEBPlanCard
													handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
													cardId="member-card"
													addBeneficiaryDetails={[
														...addMemberPrimaryBeneficiary,
														...addMemberContigentBeneficiary
													]}
													memberName={member.first_name}
													primaryBeneficiaryCount={primaryMemberBeneficiary.count}
													contingentBeneficiaryCount={contingentMemberBeneficiary.count}
													primaryBeneficiaryPercentage={primaryMemberBeneficiary.percentage}
													contingentBeneficiaryPercentage={
														contingentMemberBeneficiary.percentage
													}
													handleEdit={handleEdit}
													handleDelete={handleDelete}
												></VEBPlanCard>
											</Grid>
										) : coverage_for === "Employee & Spouse" &&
										  memberFaceAmount !== null &&
										  spouseFaceAmount !== null ? (
											<>
												<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
													<VEBPlanCard
														handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
														cardId="member-card"
														addBeneficiaryDetails={[
															...addMemberPrimaryBeneficiary,
															...addMemberContigentBeneficiary
														]}
														memberName={member.first_name}
														primaryBeneficiaryCount={primaryMemberBeneficiary.count}
														contingentBeneficiaryCount={contingentMemberBeneficiary.count}
														primaryBeneficiaryPercentage={
															primaryMemberBeneficiary.percentage
														}
														contingentBeneficiaryPercentage={
															contingentMemberBeneficiary.percentage
														}
														handleEdit={handleEdit}
														handleDelete={handleDelete}
													></VEBPlanCard>
												</Grid>
												<Grid item xl={5} lg={5} md={5} sm={5} xs={10} columnSpacing={2}>
													<VEBPlanCard
														handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
														cardId="spouse-card"
														addBeneficiaryDetails={[
															...addSpousePrimaryBeneficiary,
															...addSpouseContigentBeneficiary
														]}
														memberName={spouse === null ? "" : spouse.first_name}
														primaryBeneficiaryCount={primarySpouseBeneficiary.count}
														contingentBeneficiaryCount={contingentSpouseBeneficiary.count}
														primaryBeneficiaryPercentage={
															primarySpouseBeneficiary.percentage
														}
														contingentBeneficiaryPercentage={
															contingentSpouseBeneficiary.percentage
														}
														handleEdit={handleEdit}
														handleDelete={handleDelete}
													></VEBPlanCard>
												</Grid>
											</>
										) : null}
									</Grid>
								</AccordionDetails> */}
								</Accordion>
							</div>
							{!VEBPlanCodes2024.includes(planCode as unknown as string) ? (
								<div className="veb-disclaimer">{/* <VEBDisclaimer /> */}</div>
							) : null}
							<div className="theme-plan-option-content">
								<Checkbox
									checked={isActivelyWorking}
									style={{ paddingLeft: 0 }}
									onChange={handleIsActivelyWorkingCheckboxChange}
								/>
								<p className="theme-plan-checkbox-label">
									<strong>Are you actively at work 20 or more hours per week?</strong>
								</p>
							</div>
							<div>
								<div className="theme-plan-option-content">
									<Checkbox
										checked={hasReadTC}
										style={{ paddingLeft: 0 }}
										onChange={handleAgreedTCCheckboxChange}
									/>
									<p className="theme-plan-checkbox-label">
										<strong>
											I have read the{" "}
											<span
												className="veb-plan-disclaimer"
												style={{ color: theme.primary_color }}
												onClick={handleOpenDisclaimerDialogClick}
											>
												Disclaimer
											</span>
										</strong>
									</p>
								</div>
							</div>
							{/* <div className="theme-plan-inner-section-margin-2" />
						<Grid container>
							<Grid item xl={4} lg={4} md={4} sm={4} xs={10} columnSpacing={2}>
								<div className="details-form-row">
									<div className="details-form-label required">Writing Number</div>
									<Grid container>
										<Grid item xl={9}>
											<CustomInput value={writingNumber} onChange={handleWritingNumberChange} />
										</Grid>
										{showWritingNumberValidateButton ? (
											<Grid item xl={3}>
												<div className="writing-number-validate-container">
													<Button
														style={{
															backgroundColor: theme.button.background_color,
															color: theme.button.color,
															opacity: 0.8
														}}
													>
														Validate
													</Button>
												</div>
											</Grid>
										) : null}
									</Grid>
								</div>
							</Grid>
						</Grid> */}
							<div className="theme-plan-inner-section-margin-2" />
							<LazyPlanActions
								waiveButtonCallback={handleWaiveButtonClick}
								activateButtonCallback={handleActivateButtonClick}
							/>
						</Paper>
					</div>
				</div>
				<VEBModal
					open={modalOpen}
					familyDetails={
						selectCard === "member-card"
							? [member, ...dependents].filter((mem: Member, index: number) => {
									return ![...addMemberPrimaryBeneficiary, ...addMemberContigentBeneficiary].some(
										(val: any, index: number) => val.enrollment_id === mem._id
									);
							  })
							: [member, ...dependents].filter((mem: Member, index: number) => {
									return ![...addSpousePrimaryBeneficiary, ...addSpouseContigentBeneficiary].some(
										(val: any, index: number) => val.enrollment_id === mem._id
									);
							  })
					}
					submitBeneficiary={handleSubmitBeneficiary}
					data={editData}
					handleAddBeneficiaryDetails={handleAddBeneficiaryDetails}
					handleClose={handleClose}
				></VEBModal>
			</Suspense>
			{isDependentExistsModelOpen && (
				<ExistsDependentModelVEB
					onClose={() => setIsDependentExistsModelOpen(false)}
					dependentData={existsDependentData}
				/>
			)}
		</>
	);
};

export default KemperWholeLifeInsuaranceForm;
